import React from 'react';
import { classNames, LayoutClassNameProps } from '../atoms';
import Flex from '../molecules/Flex';

export interface CenteredPageProps extends React.HTMLAttributes<HTMLDivElement>, LayoutClassNameProps {
  constrained?: boolean;
  fixed?: boolean;
  fullViewport?: boolean;
  light?: boolean;
}

const CenteredPage: React.FC<CenteredPageProps> = ({
  constrained = false,
  fixed = false,
  fullViewport = true,
  light = false,
  className,
  style,
  children,
  ...props
}) => (
  <Flex
    direction="column"
    justify="center"
    align="center"
    className={classNames(
      'text-center',
      constrained ? 'container' : undefined,
      light ? 'bg-light' : undefined,
      fixed ? 'position-fixed top-0 start-0' : undefined,
      className,
    )}
    style={{
      ...(fullViewport ? { minHeight: '100vh' } : {}),
      ...(fixed ? { width: '100vw', zIndex: 1000 } : {}),
      ...style,
    }}
    {...props}
  >
    {children}
  </Flex>
);

export default CenteredPage;
